/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zombie_Footer_LineInputs */

const en_zombie_footer_line = /** @type {(inputs: Zombie_Footer_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZombieTrend AI turns two photos into the viral zombie love story video.`)
};

const zh_zombie_footer_line = /** @type {(inputs: Zombie_Footer_LineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ZombieTrend AI 把两张照片变成爆火的丧尸爱情故事视频。`)
};

/**
* | output |
* | --- |
* | "ZombieTrend AI turns two photos into the viral zombie love story video." |
*
* @param {Zombie_Footer_LineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const zombie_footer_line = /** @type {((inputs?: Zombie_Footer_LineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zombie_Footer_LineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zombie_footer_line(inputs)
	return zh_zombie_footer_line(inputs)
});
export { zombie_footer_line as "zombie.footer.line" }